import { PricesToFetch } from 'store/price/types';
import fetchPricesOperation from 'store/price/operation/fetchPricesOperation';
import setPricesToFetchOperation from 'store/price/operation/setPricesToFetchOperation';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { ProductItemPreviewProps } from '../types';

const fetchRecentlyViewedProductPricesOperation =
  (items: ProductItemPreviewProps[]) => async (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    const pricesToFetch: PricesToFetch = {};
    items.forEach((item) => {
      if (!item || !item.categoryId || !item.productId) {
        return;
      }

      if (!pricesToFetch[item.categoryId]) {
        pricesToFetch[item.categoryId] = {
          categoryId: item.categoryId,
          productIds: [item.productId],
          encryptedDesignId: '',
        };
      } else {
        pricesToFetch[item.categoryId].productIds.push(item.productId);
      }
    });
    dispatch(setPricesToFetchOperation(pricesToFetch));
    dispatch(fetchPricesOperation());
  };

export default fetchRecentlyViewedProductPricesOperation;
